
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-rasayel-alternative",
      function () {
        return require("private-next-pages/best-rasayel-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-rasayel-alternative"])
      });
    }
  